import { z } from 'zod';
import { serviceName } from '../base/index.js';
export const veriskEdiServiceName = serviceName;
export const VeriskEdiInterfaceParameterSchema = z.enum(['VERISK_EDI_EXPORT_BUCKET_ARN']);
export const VeriskEdiParameterEnum = VeriskEdiInterfaceParameterSchema.enum;
